import { useMediaQuery } from 'react-responsive';

function SmartComponent<PropsType, StateType>(
    useInitialState: (props: PropsType) => StateType,
    renderDesktop: (props: StateType) => JSX.Element,
    renderMobile: (props: StateType) => JSX.Element = null,
): (props: PropsType) => JSX.Element {
    const Component = (props: PropsType) => {
        const isMobile = useMediaQuery({
            query: 'screen and (max-width: 995px)',
        });

        const state = useInitialState(props);

        if (isMobile && renderMobile !== null) {
            return renderMobile({ ...state });
        } else {
            return renderDesktop({ ...state });
        }
    };

    return Component;
}

export default SmartComponent;
